/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { ICreateBoxArgs } from "./components";

const is = require("is_js");

const SERVICE_NAME = "OpenRegistrationCostumePageService";
const log: any = LoggerModule.getInstance();

export class OpenRegistrationCostumePageService {
  private static instance: OpenRegistrationCostumePageService;
  private vapp: VApplication;
  private selectedCostume: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): OpenRegistrationCostumePageService {
    if (!OpenRegistrationCostumePageService.instance) {
      OpenRegistrationCostumePageService.instance = new OpenRegistrationCostumePageService(props);
    }
    return OpenRegistrationCostumePageService.instance;
  }

  public setSelectedCostume(data: any) {
    this.selectedCostume = data;
  }

  public getSelectedCostume() {
    return this.selectedCostume;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPresentation() {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getPresentation();

    return content;
  }
  public async getPreBookedAmt() {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getPreBookedAmt();

    return content;
  }

  public async getCostumeType(costumeId: string) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getCostumeType(costumeId);

    return content;
  }

  public async getCities() {
    const agent = getAgent();
    let content: any = {};
    let compProps: any = null;
    compProps = await agent.getMyDiscounts();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async createBox(payload: ICreateBoxArgs) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.createBox(payload);

    return content;
  }
  public async createPayFAC(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.createPayFAC({ ...arg });
    return content;
  }
  public async validateDiscount(args: any) {
    console.log(args)
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.validateDiscount(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }
}
